export enum RequestStep {
  ParentData = 0,
  ChildData,
  InstitutionProgramData,
  InitialQuestionnaireData,
  DocumentationData,
  Approval,
}
